import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

//import Breadcrumbs
import Breadcrumbs from "../../components/common/Breadcrumb";
import { Loading } from "../../components/common/Loading";

import {
  Button,
  Card, CardBody, Col,
  Container,
  Row
} from "reactstrap";

import { FieldArray, Form, Formik} from "formik";
import { XSelect } from "../../components/common/inputs/XSelect";
import { XTextArea } from "../../components/common/inputs/XTextArea";
import { XTextBox } from "../../components/common/inputs/XTextBox";
import { Endpoints } from "../../utils/Endpoints";
import InvoiceSummary from "../Sales/InvoiceSummary";
import { ApiCore } from "../../helpers/api_helper";
import { amountToCurrency, currentDate } from "../../utils/Helpers";
import { ISelectOption } from "../../interfaces/inputs/ISelectOption";
import { XDatePickerField } from "../../components/common/inputs/XDatePickerField";
import { AxiosError, AxiosResponse } from "axios";
import XModal from "../../components/common/XModal";
import { SupplierFields } from "../../fields/SupplierFields";
import { SupplierSchema } from "../../schemas/SupplierSchema";
import CreateForm from "../../components/forms/CreateForm";
import { useLocation, useHistory } from "react-router-dom";
import { ISupplier } from "../../interfaces/suppliers/ISupplier";
import { IProduct } from "../../interfaces/products/IProduct";
import { ProductFields } from "../../fields/ProductFields";
import { ProductSchema } from "../../schemas/ProductSchema";
import { XSearchableSelect } from "../../components/common/inputs/XSearchableSelect";

const NewSale = () => {

  const [defaults, setDefaults] = useState<any>({});
  const [companies, setCompanies] = useState<any>([]);
  const [products, setProducts] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingVoucher, setLoadingVoucher] = useState<boolean>(true);
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const params = new URLSearchParams(useLocation().search);
  const invtype = params.get("invtype") ? params.get("invtype") : "sale";
  const [showSupplierDialog, setShowSupplierDialog] = useState<boolean>(false);
  const [showProductDialog, setShowProductDialog] = useState<boolean>(false);
  const getDefaultAccount = () => {
    if (defaults.accounts) {
      if (invtype == "sale" && defaults.accounts.receivable) {
        return defaults.accounts.receivable;
      } else if (invtype == "purchase" && defaults.accounts.payable) {
        return defaults.accounts.payable;
      }
    }
    return 0;
  }
  const [voucher, setVoucher] = useState<any>(null);

  const history = useHistory();

  const request = new ApiCore();

  const voucherId = params.get("id") ? params.get("id") : null;
  const invoiceId = params.get("invoiceId") ? params.get("invoiceId") : null;
  const companyId = params.get("companyId") ? params.get("companyId") : "";
  const balance = params.get("balance") ? params.get("balance") : null;

  if (voucherId) {
    useEffect(() => {
      request
        .get(Endpoints.vouchers + "/" + voucherId)
        .then((response: AxiosResponse) => {
          setVoucher(response.data);     
          setLoadingVoucher(false);    
        })
        .catch(error => {
          console.error(error);
        });
    }, []);
  }

  useEffect(() => {
    request
      .get(Endpoints.defaults)
      .then((response: AxiosResponse) => {
        setDefaults(response.data);
        setLoading(false);
        if (!voucherId) {
          setLoadingVoucher(false);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {

    request.get(Endpoints.companies, {})
      .then((response: AxiosResponse) => {
        const { companies } = response.data;
        let options: any = []
        options = companies.map((data: any) => ({
          value: data.id,
          label: data.name || data.taxid,
          data: JSON.stringify(data)
        }))
        setCompanies(options);
        initialValues.company_id = "";

      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {

    request.get(Endpoints.products, {})
      .then((response: AxiosResponse) => {
        const { products, totalRecords } = response.data;
        let options: any = []
        options = products.map((data: any) => ({
          value: data.id,
          label: data.name || data.taxid,
          data: JSON.stringify(data)
        }))
        setProducts(options);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);  

  let initialValues: any = {}
  if (voucher) {
    initialValues = {
      company_id: voucher.company_id ? voucher.company_id : "",
      account_id: voucher.account_id ? voucher.account_id : "",
      currency_id: voucher.currency ? voucher.currency.id : "",
      currency: voucher.currency,
      bank_id: voucher.bank_id ? voucher.bank_id : "",
      whduty_id: voucher.whduty_id ? voucher.whduty_id : "",
      created: voucher.created ? voucher.created : "",
      rate: voucher.rate ? voucher.rate : 1,
      items: voucher.items.map((item: any) => {
        return item;
      })
    }
  } else {
    initialValues = {
      company_id: companyId,
      account_id: defaults.accounts ? defaults.accounts.cash : "",
      currency_id: defaults.currency ? defaults.currency.id : "",
      currency: defaults.currency,
      invoice_id: invoiceId ? invoiceId : "",
      bank_id: "",
      whduty_id: "",
      created: currentDate(),
      rate: defaults.currency ? defaults.currency.rate : 1,
      items: [
        {
          product_id: "",
          craccountid: defaults.accounts ? (invoiceId ? defaults.accounts.payable : defaults.accounts.liability) : "",
          particulars: "",
          amount: balance
        }
      ]
    }
  }


  const computeSubTotal = (items: [any]) => {
    const sum = items.reduce((accumulator, object) => {
      return accumulator + Number(object.amount);
    }, 0);
    return sum;
  }

  const handleClickNewCompany = () => {
    setShowSupplierDialog(true);
  };

  const handleCreateCompany = (supplier: ISupplier, f: any) => {
    const updatedCompanies = [...companies, {
      value: supplier.id,
      label: supplier.name,
      data: JSON.stringify(supplier)
    }]
    setCompanies(updatedCompanies);
    f('company_id',supplier.id);
  };

  const handleSubmit = (values: any) => {
    const request_body = values;
    request_body.generaljournals_attributes = request_body.items;
    if (voucherId) {
      request_body.id = voucherId;
      request.update(Endpoints.vouchers + "/" + voucherId, request_body)
        .then((response: AxiosResponse) => {
          history.push('/transactions/vouchers/' + response.data.id)
        }).catch((error: AxiosError) => {
          console.log(error)
        })
    } else {
      request.create(Endpoints.vouchers, request_body)
        .then((response: AxiosResponse) => {
          history.push('/transactions/vouchers/' + response.data.id)
        }).catch((error: AxiosError) => {
          console.log(error)
        })
    }
  };

  const getCurrencyCode = (currency: any) => {
    return currency ? currency.code : "UGX";
  }

  const handleClickNewProduct = (index: number) => {
    setSelectedIndex(index);
    setShowProductDialog(true);
  };

  const handleCreateProduct = (product: IProduct, f: any, values: any) => {
    const updatedProducts = [...products, {
      value: product.id,
      label: product.name,
      data: JSON.stringify(product)
    }];

    setProducts(updatedProducts);
    f(`items.${selectedIndex}.product_id`, product.id)

    f(`items.${selectedIndex}.quantity`, 1)
    f(`items.${selectedIndex}.rate`, product.sellingprice)
    f(`items.${selectedIndex}.particulars`, product.name)
    if (values.invtype == "sale") {
      f(`items.${selectedIndex}.craccountid`, product.salesaccount);
    } else {
      f(`items.${selectedIndex}.craccountid`, product.purchaseaccount);
    }
  };
  
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Create a voucher | Treda</title>
        </MetaTags>

        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Transactions" breadcrumbItem="Create a voucher" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {(loading || loadingVoucher) && <Loading label="Loading voucher. Please wait." />}
                  {(!loading && !loadingVoucher) && (
                    <>
                      <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validateOnBlur
                        onSubmit={(values: any) => handleSubmit(values)}>

                        {({ isSubmitting, setFieldValue, values, errors, touched }) => (
                          <>
                          <XModal title={"Add a Supplier"}
                            width={"lg"}
                            open={showSupplierDialog}
                            toggle={() => setShowSupplierDialog(!showSupplierDialog)}
                            onClose={() => setShowSupplierDialog(false)}>

                            <CreateForm
                              fields={SupplierFields}
                              initialValues={initialValues}
                              enableReinitialize={true}
                              submitEndpoint={Endpoints.companies}
                              submitButtonLabel={"Create supplier"}
                              validationSchema={SupplierSchema}
                              debug={false}
                              handleUpdate={(supplier: ISupplier) => {
                                handleCreateCompany(supplier, setFieldValue);
                              }}
                              onClose={() => setShowSupplierDialog(false)} />

                          </XModal>
                          <XModal title={"Add a product"}
                                width={"lg"}
                                open={showProductDialog}
                                toggle={() => setShowProductDialog(!showProductDialog)}
                                onClose={() => setShowProductDialog(false)}>

                            <CreateForm
                              fields={ProductFields}
                              initialValues={initialValues}
                              submitEndpoint={Endpoints.products}
                              submitButtonLabel={"Create Product"}
                              validationSchema={ProductSchema}
                              debug={false}
                              handleUpdate={(product: IProduct) => {
                                handleCreateProduct(product, setFieldValue, values);
                              }}
                              onClose={() => setShowProductDialog(false)} />

                          </XModal>
                          <Form>
                            <Row>
                              <Col lg={2}>
                                <XDatePickerField key="created" id="created"
                                  name={"created"}
                                  label={"Date"}
                                  touched={touched}
                                  onChange={setFieldValue}
                                  value={values.created}
                                  errors={errors} />
                              </Col>
                              <Col lg={3}>
                                <XSearchableSelect
                                    key="company_id"
                                    id="company_id"
                                    value={values.company_id}
                                    name={"company_id"}
                                    options={companies}
                                    label={"Received From"}
                                    handleNewClick={e => {
                                      handleClickNewCompany();
                                    }}
                                    onChange={(value: any) => {
                                      setFieldValue("company_id", value.value);
                                    }}
                                    touched={touched}
                                    errors={errors}
                                  />
                              </Col>

                              <Col lg={2}>
                                <XSearchableSelect
                                  key="account_id"
                                  id="account_id"
                                  name={"account_id"}
                                  onChange={(value: any) => {
                                    setFieldValue("account_id", value.value);
                                  }}
                                  dataSrc={Endpoints.accounts}
                                  value={values.account_id}
                                  dataType={"accounts"}
                                  label={"Debit Account"}
                                  touched={touched}
                                  errors={errors}
                                />
                              </Col>

                              <Col lg={2}>
                                <XSelect
                                  key="bank_id"
                                  id="bank_id"
                                  name={"bank_id"}
                                  dataSrc={Endpoints.banks}
                                  dataType={"banks"}
                                  label={"Bank"}
                                  touched={touched}
                                  errors={errors} />
                              </Col>
                              <Col lg={2}>
                                <XSelect key="currency_id" id="currency_id"
                                  name={"currency_id"}
                                  dataSrc={Endpoints.currencies}
                                  onChange={(field: any) => {
                                    const data = JSON.parse(field.target.selectedOptions[0].dataset.raw);

                                    setFieldValue(field.target.name, data.id);
                                    setFieldValue(`currency`, data);
                                    setFieldValue(`rate`, data.rate);
                                  }}
                                  dataType={"currencies"}
                                  label={"Currency"}
                                  touched={touched}
                                  errors={errors} />
                              </Col>
                              <Col lg={1}>
                                <XTextBox
                                  key="rate"
                                  id="rate"
                                  type={"text"}
                                  name={"rate"}
                                  label={"Rate"}
                                  touched={touched}
                                  errors={errors} />
                              </Col>
                            </Row>

                            <Row>
                              <Col lg={12}>
                                <div className={"mt-4 border-top border-bottom pt-2 bg-light"}>
                                  <Row>
                                    <Col lg={2} className="px-4"><h6>Item</h6></Col>
                                    <Col lg={3}><h6>Particulars</h6></Col>
                                    <Col lg={4}><h6>Account</h6></Col>
                                    <Col lg={2}><h6>Amount</h6></Col>
                                    <Col lg={1}></Col>
                                  </Row>
                                </div>
                              </Col>

                              <Col lg={12}>
                                <FieldArray name={"items"} render={arrayHelpers => (
                                  <div className={"py-3"}>
                                    {values.items &&
                                      values.items.map((item: any, index: number) => (
                                        <Row key={index}>
                                          <Col lg={2}>
                                            <XSearchableSelect
                                              onChange={(field: any) => {
                                                const productId = field.value;
                                                if (productId == -1) {
                                                  handleClickNewProduct(index);
                                                } else {
                                                  setFieldValue(`items.${index}.product_id`,productId);
                                                  const data = JSON.parse(field.data);

                                                  setFieldValue(`items.${index}.quantity`, 1);
                                                  setFieldValue(`items.${index}.rate`, data.sellingprice);
                                                  setFieldValue(`items.${index}.particulars`, data.name);
                                                  setFieldValue(`items.${index}.draccountid`, data.purchaseaccount);
                                                }
                                              }}
                                              allowAddNew={true}
                                              options={products}
                                              id={`items.${index}.product_id`}
                                              name={`items.${index}.product_id`}
                                              value={values.items[index].product_id}
                                              touched={touched}
                                            />
                                          </Col>
                                          <Col lg={3}>
                                            <XTextBox
                                              id={`items.${index}.particulars`}
                                              type={"text"}
                                              name={`items.${index}.particulars`}
                                              touched={touched}
                                              errors={errors} />
                                          </Col>
                                          <Col lg={4}>
                                            <XSearchableSelect
                                              dataType={"accounts"}
                                              dataSrc={Endpoints.accounts}
                                              id={`items.${index}.draccountid`}
                                              name={`items.${index}.draccountid`}
                                              value={values.items[index].draccountid}
                                              onChange={(value: any) => {
                                                setFieldValue(`items.${index}.draccountid`, value.value);
                                              }}
                                              touched={touched} />
                                          </Col>
                                          <Col lg={2}>
                                            <XTextBox
                                              id={`items.${index}.amount`}
                                              type={"text"}
                                              name={`items.${index}.amount`}
                                              touched={touched}
                                              errors={errors} />
                                          </Col>
                                          <Col lg={1}>
                                            <Button className={"btn btn-soft-danger"} to={"#"}>
                                              <i className="fa fa-times"
                                                onClick={() => arrayHelpers.remove(index)}></i>
                                            </Button>
                                          </Col>
                                        </Row>
                                      )
                                      )}
                                    <Button
                                      className={"btn btn-soft-primary"}
                                      type="button"
                                      onClick={() => arrayHelpers.push({
                                        product_id: "",
                                        craccountid: "",
                                        particulars: "",
                                        amount: "",
                                      })}>
                                      <i className={"mdi mdi-plus"}></i> Add Item
                                    </Button>

                                  </div>
                                )} />
                              </Col>

                            </Row>

                            <Row>
                              <XTextArea id="remarks" label="Remarks" name="remarks" size={{ lg: 12 }} touched={touched} />
                            </Row>

                            <Row>
                              <Col lg={3}>
                                <InvoiceSummary label={"Sub total"} icon="mdi mdi-calculator" value={getCurrencyCode(values.currency) + " " + amountToCurrency(computeSubTotal(values.items))} />
                              </Col>
                            </Row>

                            <div className="modal-footer">
                              <Button disabled={isSubmitting} type="submit" className="btn btn-primary">
                                Save
                              </Button>
                            </div>

                          </Form>
                          </>

                        )}


                      </Formik>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default NewSale;